import {
    ButtonProps,
    Group
} from "@mantine/core";

import {
    Field,
    Form,
    Formik
} from 'formik';
import {
    FlexiButton,
    FormikCheckbox,
    PlatformFieldset
} from "@flexinet/ui-components";
import {useDeleteAccountForm} from "../hooks/useDeleteAccountForm.ts";
import {DeleteAccountFormRecordSchema} from "./DeleteAccountFormRecordSchema.ts";


const RegisterButton = (props: ButtonProps & { type: "button" | "submit" | "reset" | undefined }) =>
    <FlexiButton {...props} />

export const DeleteAccountForm = () => {

    const {
        initialValues,
        handleSubmit,
        handleCancel
    } = useDeleteAccountForm()


    return (
        <div>
            <Formik
                initialValues={initialValues}
                validationSchema={DeleteAccountFormRecordSchema}
                onSubmit={handleSubmit}
            >
                {({
                      isSubmitting,
                  }) => (

                    <Form>
                        <PlatformFieldset legend={'Confirm Delete Account'}>


                            <Field name="confirmation"
                                   label={"I understand that I may lose access to my account if I delete it."}
                                   component={FormikCheckbox}
                                   my={'lg'}
                            ></Field>
                        </PlatformFieldset>


                        <Group justify={'flex-end'} my={'sm'}>
                            <FlexiButton variant={'subtle'} onClick={handleCancel}>Cancel</FlexiButton>
                            <RegisterButton variant={'filled'} disabled={isSubmitting}
                                            type={'submit'}>Confirm</RegisterButton>
                        </Group>

                    </Form>

                )}
            </Formik>
        </div>
    )
};

